// Toaster · shadcn-style wrapper around `sonner`.
//
// Feb 2026 fix — the original wrapper pulled `theme` from `next-themes`'
// `useTheme()`. Cruise Command doesn't wrap the tree in a
// <ThemeProvider>, so `useTheme()` returned an incomplete context and
// Sonner silently rendered nothing. Every toast (`RelationshipPicker`
// quick-create, `RelationshipEditDrawer` save, etc.) was being dropped.
// Hardcoding `theme="light"` reliably mounts the Sonner container and
// keeps our shadcn class-name overrides intact.
import { Toaster as Sonner, toast } from "sonner";

const Toaster = ({ ...props }) => (
  <Sonner
    theme="light"
    position="bottom-right"
    richColors
    closeButton
    className="toaster group"
    toastOptions={{
      classNames: {
        toast:
          "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
        description: "group-[.toast]:text-muted-foreground",
        actionButton:
          "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        cancelButton:
          "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
      },
    }}
    {...props}
  />
);

export { Toaster, toast };
